import useAppUserPermissions from 'hooks/useAppUserPermissions';

const useManagePropertyPermissionsAllowed = () => {
  const permissions = useAppUserPermissions();
  return permissions.includes('Properties:ManagePermissions');
};

export default useManagePropertyPermissionsAllowed;
